import React, { FC } from 'react';
import { Descriptions, DescriptionsRow } from 'common/components';
import { dateFormatter, phoneFormatter } from 'common/helpers';
import { AuthHooks } from 'common/hooks';
import { EDeliveryType, EDeliveryTypeLabel, IBasket } from 'entities/Basket/Basket.models';

interface IComponentProps {
  basket: IBasket;
  onMethodChange: () => void;
}

export const BasketDeliveryDetails: FC<IComponentProps> = ({ basket, onMethodChange }) => {
  const { isSeller } = AuthHooks.useIsSeller();

  return (
    <div>
      <div className="mb-6 flex align-center justify-between">
        <span className="ff-medium fs-m">Детали получения</span>

        {!isSeller && (
          <span className="ff-semibold fs-xs color-dark-green cursor-pointer" onClick={onMethodChange}>
            Изменить способ
          </span>
        )}
      </div>

      <Descriptions>
        <DescriptionsRow label="Способ получения" value={EDeliveryTypeLabel[basket.deliveryType as EDeliveryType]} />
        <DescriptionsRow
          label="Дата"
          value={basket.deliveryDate ? dateFormatter('DD.MM.YYYY (dd)', basket.deliveryDate) : 'Менеджер уточнит дату поставки'}
        />
        <DescriptionsRow label="Контактное лицо" value={basket.assignee} />
        <DescriptionsRow label="Номер телефона" value={phoneFormatter(basket.phone)} />
      </Descriptions>
    </div>
  );
};
